// Import custom flags from the specified subfolder
import swahiliFlag from '/custom-flags/swahili.png?url';
import kannadaFlag from '/custom-flags/kannada.svg?url';
import galiciaFlag from '/custom-flags/galicia.svg?url';
// Import other custom flags here as needed, e.g.:
// import someOtherFlag from '@/assets/custom-flags/some-other-flag.svg';

/**
 * A mapping from specific language codes (e.g., 'sw-KE') to their custom flag image assets.
 * Add new entries here for additional custom flags.
 */
const customFlagMap: Record<string, string> = {
  'sw-KE': swahiliFlag,
  'kn-IN': kannadaFlag,
  'gl-ES': galiciaFlag,
  // 'xx-YY': someOtherFlag, // Example for future additions
};

/**
 * Retrieves the path to a custom flag image for a given language code, if one exists.
 * @param languageCode The full language code (e.g., 'sw-KE', 'kn-IN').
 * @returns The path to the custom flag image asset, or null if no custom flag is defined for the code.
 */
export const getCustomFlagPath = (languageCode: string): string | null => {
  return customFlagMap[languageCode] || null;
};
